import Splide from '@splidejs/splide';

let logoSlides = document.getElementsByClassName('logo-slider');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < logoSlides.length; i++) {

        let splide = new Splide(logoSlides[i], {
            type: 'slide',
            perPage: 8,
            perMove: 1,
            rewind: true,
            pagination: false,
            arrows: true,
            width: '100%',
            breakpoints: {
                1023: {
                    perPage: 6,
                },
                640: {
                    perPage: 4,
                },
            },
        });

        let bar = splide.root.querySelector('.splide-progress-bar');
        let indicatorCurrent = splide.root.querySelector('.splide-indicator .current');
        let indicatorTotal = splide.root.querySelector('.splide-indicator .total');

        splide.on('mounted move', function () {
            let end = splide.Components.Controller.getEnd() + 1;
            bar.style.width = String(100 * (splide.index + 1) / end) + '%';
            indicatorCurrent.innerHTML = splide.index + 1;
            indicatorTotal.innerHTML = end;
        });

        splide.mount();
    }
});
